export const APP_BANNERS_LABELS = {
  supportPortal: 'Support Portal',
} as const
